(function () {
  if (window.__shufooniLandingPageReady) return;
  window.__shufooniLandingPageReady = true;

  var pageName = "beard_kit_landing";
  var sent = {};

  var metaKits = {
    "50788379918583": {
      productId: "9977998967031",
      value: 149
    },
    "50788375232759": {
      productId: "9977996968183",
      value: 199
    },
    "50845407445239": {
      productId: "9998216429815",
      value: 229
    }
  };

  function metaEventId(eventName) {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return eventName + "_" + window.crypto.randomUUID();
    }

    return eventName + "_" + Date.now() + "_" + Math.random().toString(36).slice(2);
  }

  function trackMetaWhenReady(onceKey, eventName, data) {
    var eventId = metaEventId(eventName);
    var attempts = 0;

    function send() {
      if (sent[onceKey]) return;

      if (typeof window.fbq === "function") {
        sent[onceKey] = true;
        window.fbq("track", eventName, data, {
          eventID: eventId
        });
        return;
      }

      attempts += 1;
      if (attempts < 20) {
        window.setTimeout(send, 250);
      }
    }

    send();
  }

  function trackMetaAddToCart(clickData) {
    var kit = metaKits[clickData.variant_id];
    if (!kit || typeof window.fbq !== "function") return;

    window.fbq("track", "AddToCart", {
      content_name: clickData.kit_title,
      content_category: "beard-kits",
      content_type: "product",
      content_ids: [clickData.variant_id],
      value: kit.value,
      currency: "ILS"
    }, {
      eventID: metaEventId("AddToCart")
    });
  }

  function params(extra) {
    var query = new URLSearchParams(window.location.search);
    return Object.assign({
      page_name: pageName,
      page_path: window.location.pathname,
      page_location: window.location.href,
      utm_source: query.get("utm_source") || "",
      utm_campaign: query.get("utm_campaign") || "",
      utm_content: query.get("utm_content") || "",
      utm_medium: query.get("utm_medium") || ""
    }, extra || {});
  }

  function emit(name, data, callback) {
    var payload = params(data);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, payload));

    var callbackDone = false;
    var done = function () {
      if (callbackDone) return;
      callbackDone = true;
      if (typeof callback === "function") callback();
    };

    if (typeof window.gtag === "function") {
      window.gtag("event", name, Object.assign({}, payload, {
        transport_type: "beacon",
        event_callback: done,
        event_timeout: 500
      }));
    } else {
      done();
    }

    if (typeof window.fbq === "function") {
      window.fbq("trackCustom", name, payload);
    }

    if (typeof callback === "function") {
      window.setTimeout(done, 560);
    }
  }

  function emitOnce(key, name, data) {
    if (sent[key]) return;
    sent[key] = true;
    emit(name, data);
  }

  function stageName(section) {
    return section.getAttribute("data-shufooni-stage") || "unknown";
  }

  function initSectionViews() {
    var sections = Array.prototype.slice.call(document.querySelectorAll("[data-shufooni-stage]"));
    if (!sections.length || !("IntersectionObserver" in window)) {
      sections.forEach(function (section) {
        emitOnce("section:" + stageName(section), "shufooni_lp_section_view", {
          section_name: stageName(section)
        });
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var section = stageName(entry.target);
        emitOnce("section:" + section, "shufooni_lp_section_view", {
          section_name: section,
          visible_ratio: Math.round(entry.intersectionRatio * 100)
        });
      });
    }, { threshold: [0.38] });

    sections.forEach(function (section) { observer.observe(section); });
  }

  function initKitViews() {
    var cards = Array.prototype.slice.call(document.querySelectorAll("[data-shufooni-kit-card]"));
    if (!cards.length || !("IntersectionObserver" in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var card = entry.target;
        var kitKey = card.getAttribute("data-kit") || "";
        var title = card.querySelector("h3");
        emitOnce("kit_view:" + kitKey, "shufooni_lp_offer_view", {
          kit_key: kitKey,
          kit_title: title ? title.textContent.trim() : ""
        });
      });
    }, { threshold: [0.5] });

    cards.forEach(function (card) { observer.observe(card); });
  }

  function initScrollDepth() {
    var marks = [25, 50, 75, 90];
    var ticking = false;

    function check() {
      ticking = false;
      var doc = document.documentElement;
      var max = Math.max(1, doc.scrollHeight - window.innerHeight);
      var current = Math.round((window.scrollY / max) * 100);
      marks.forEach(function (mark) {
        if (current >= mark) {
          emitOnce("scroll:" + mark, "shufooni_lp_scroll_depth", {
            scroll_depth: mark
          });
        }
      });
    }

    window.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(check);
    }, { passive: true });
    check();
  }

  function initStickyCta() {
    var sticky = document.querySelector("[data-shufooni-sticky-cta]");
    if (!sticky) return;

    function update() {
      var shouldShow = window.innerWidth < 990 && window.scrollY > Math.min(640, window.innerHeight * 0.6);
      sticky.classList.toggle("is-visible", shouldShow);
    }

    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  function shouldDelayNavigation(event, link) {
    if (!link || !link.href) return false;
    if (event.defaultPrevented) return false;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    if (link.target && link.target !== "_self") return false;
    return link.origin === window.location.origin && link.pathname.indexOf("/cart/") === 0;
  }

  function initClicks() {
    document.addEventListener("click", function (event) {
      var checkout = event.target.closest(".shufooni-checkout-button");
      if (checkout) {
        var data = {
          kit_key: checkout.getAttribute("data-kit-key") || "",
          kit_title: checkout.getAttribute("data-kit-title") || "",
          variant_id: checkout.getAttribute("data-variant-id") || "",
          discount_code: checkout.getAttribute("data-discount-code") || ""
        };

        trackMetaAddToCart(data);

        if (shouldDelayNavigation(event, checkout)) {
          event.preventDefault();
          emit("shufooni_lp_checkout_click", data, function () {
            window.location.href = checkout.href;
          });
        } else {
          emit("shufooni_lp_checkout_click", data);
        }
        return;
      }

      var offerScroll = event.target.closest(".shufooni-scroll-to-offers");
      if (offerScroll) {
        emit("shufooni_lp_cta_click", {
          cta_text: offerScroll.textContent.trim(),
          cta_target: offerScroll.getAttribute("href") || ""
        });
        return;
      }

      var secondary = event.target.closest(".shufooni-lp-secondary-link");
      if (secondary) {
        emit("shufooni_lp_secondary_click", {
          cta_text: secondary.textContent.trim(),
          cta_target: secondary.getAttribute("href") || ""
        });
        return;
      }

      var video = event.target.closest("[data-shufooni-video-title]");
      if (video) {
        emit("shufooni_lp_video_engage", {
          video_title: video.getAttribute("data-shufooni-video-title") || ""
        });
      }
    });

    document.querySelectorAll(".shufooni-lp-faq details").forEach(function (item) {
      item.addEventListener("toggle", function () {
        if (!item.open) return;
        var summary = item.querySelector("summary");
        emit("shufooni_lp_faq_open", {
          question: summary ? summary.textContent.trim() : ""
        });
      });
    });

    document.querySelectorAll("[data-reviews-load]").forEach(function (button) {
      button.addEventListener("click", function () {
        emit("shufooni_lp_reviews_more", {
          cta_text: button.textContent.trim()
        });
      });
    });
  }

  function init() {
    emitOnce("page_view", "shufooni_lp_view", {
      viewport_width: window.innerWidth,
      viewport_height: window.innerHeight
    });
    trackMetaWhenReady("meta_view_content", "ViewContent", {
      content_name: "ערכת טיפוח לזקן — שופוני",
      content_category: "beard-kits",
      content_type: "product",
      content_ids: [
        "50788379918583",
        "50788375232759",
        "50845407445239"
      ],
      value: 199,
      currency: "ILS"
    });
    initSectionViews();
    initKitViews();
    initScrollDepth();
    initStickyCta();
    initClicks();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
